module.exports = __webpack_public_path__ + "img/mlbb.de40d01.png";